import LogRocket from "logrocket";
import {logRocketClient} from "./clients/log-rocket-client";
import {IProductMonitoringIdentifySessionTraits, IProductMonitoringIdentifySessionUser } from "./user-identify-types";
import {getComputerId} from "../device/deviceInfo";
import {IProductMonitoringTrackEventProperties} from "./event-property-types";


/**
 * All product monitoring and crash reporting tools can be implemented with this service.
 * For example, if we start to use MixPanel or Raygun or Sentry or FullStory or Heap, they can be added here.
 */
class ProductMonitoring {

  initialize() {
    // initialize LogRocket client
    logRocketClient.initialize();
  }

  getReduxMiddlewares() {
    return [
      LogRocket.reduxMiddleware(),
    ]
  }

  /**
   * reset user session
   */
  public resetSession(): void {
    // send session reset to LogRocket client
    logRocketClient.resetSession();
  }

  /**
   * identify user with current session
   */
  public identifySession({userId, sessionId, username, firstName, lastName}: IProductMonitoringIdentifySessionUser = {}) {

    if (!userId || !sessionId){
      // we don't have a userId or session id, unable to identify
      // return to exit
      return;
    }

    const sessionUserTraits: IProductMonitoringIdentifySessionTraits = {
      computerUuid: getComputerId(),
      userId,
      sessionId,
    };

    if (firstName || lastName) {
      // add name to LogRocket user traits
      sessionUserTraits.name = (`${firstName} ${lastName}`).trim();
    }

    if (username) {
      // add name to LogRocket user traits
      sessionUserTraits.username = `${username}`;
    }

    // send user identify to LogRocket client
    logRocketClient.identifySession(sessionUserTraits);
  }

  /**
   * Log exception
   */
  public logException(exception: Error, extraData?: {[key: string]: string | number | boolean}) {
    // pass exception to LogRocket client
    logRocketClient.logException(exception, extraData);
  }

  /**
   * Log event
   */
  public logEvent(eventName: string, eventProperties?: IProductMonitoringTrackEventProperties): void {
    // pass event to be logged, to LogRocket client
    logRocketClient.track(eventName, eventProperties);
  }
}

const productMonitoring = new ProductMonitoring();

export default productMonitoring;